import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { MetaPixelService } from './meta-pixel.service';

declare global { interface Window { dataLayer?: any[]; } }

@Injectable()
export class GtmTitleStrategy extends TitleStrategy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly metaPixel = inject(MetaPixelService);
  constructor(private readonly title: Title) { super(); }

  override updateTitle(state: RouterStateSnapshot): void {
    const built = this.buildTitle(state);
    const pageTitle = this.applySiteSuffix(built);
    if (pageTitle) this.title.setTitle(pageTitle);

    // GTM push — doar în browser (nu în prerender/SSR) și nu pe rute /platform
    if (!isPlatformBrowser(this.platformId)) return;
    if (state.url.split('?')[0].startsWith('/platform')) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ng_route_change',
      page_location: window.location.href,
      page_path: state.url.split('?')[0],
      page_title: this.title.getTitle(),
    });

    this.metaPixel.pageView(state.url);
  }

  private applySiteSuffix(title?: string): string {
    const siteName = 'Casuta Jocului';
    const normalizedSite = siteName.toLowerCase();
    const trimmed = (title ?? '').trim();
    if (!trimmed) return siteName;
    if (trimmed.toLowerCase().includes(normalizedSite)) return trimmed;
    return `${trimmed} - ${siteName}`;
  }
}
